import React from 'react'

import { useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { buildNormalAnswersArrayData, type NormalAnswerData } from '../utils'

import { useMapGroup } from './useMapGroup'
import { useMapGroupsDiff } from './useMapGroupsDiff'
import { useTotalData } from './useTotalData'

export const useNormalAnswersArrayData = (): NormalAnswerData[][] => {
  const questionQueryData = useAtomValueContext('questionQueryData')
  const questions = useSurveyQueryQuestions()
  const mapGroup = useMapGroup()
  const mapGroupsDiff = useMapGroupsDiff()
  const totalData = useTotalData()

  return React.useMemo(
    () =>
      buildNormalAnswersArrayData({
        mapGroup,
        mapGroupsDiff,
        questionIds: questionQueryData?.questions ?? [],
        questions,
        results: questionQueryData?.results ?? [],
        totalCounts: totalData.counts,
      }),
    [
      mapGroup,
      mapGroupsDiff,
      questionQueryData?.questions,
      questionQueryData?.results,
      questions,
      totalData.counts,
    ],
  )
}
